import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-ice-light text-navy" data-id="element-27" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="vtxmqd21djyh">
        <h2 id="bonos" className="font-display text-3xl font-extrabold leading-none tracking-tight sm:text-4xl" data-id="element-29" data-mp="qu30imt7hijr">
          <span className="rounded-lg bg-cta px-2 py-0.5 text-white" data-id="element-30" data-mp="14rzvjes0hgwb">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-slate-600" data-id="element-31" data-mp="zsn9uxcvmfvb">
          Y además recibes 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-brand" data-id="element-32" data-mp="19k134ne8ijg0">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="1nkvg7jc898l0">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-brand bg-white text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-34" data-mp="1jjryeramd2h5" data-mpi={i}>
              <span className="bg-brand px-2.5 py-1 font-sub text-sm font-semibold text-white" data-id="element-35" data-mp="2kb1z3afb6tx">
                Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-36" data-mp="cklf6nwgke93">
                <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-37" data-mp="chz80pdhc0re">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-slate-600 sm:text-sm" data-id="element-38" data-mp="lblpdagxx1h2">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-slate-600" data-id="element-39" data-mp="q9vo1v1vik7f">
                  Valor: <span className="text-cta line-through decoration-2" data-id="element-40" data-mp="vbcndm4plylw">{bono.value}</span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-cta bg-navy px-3 py-2.5 leading-tight" data-id="element-41" data-mp="akpfmbouqrej">
          <p className="font-sub text-base font-semibold text-white" data-id="element-42" data-mp="5mxeqs68buy7">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-ice line-through decoration-2" data-id="element-43" data-mp="kbttf82sk67s">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-sm font-extrabold uppercase text-yellow-300" data-id="element-44" data-mp="fjjx9ab329x2">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}